export const accountability = {
    title: "Accountability Board",
    delete: {
      workStream: {
        title: "Delete Work Stream",
        message: "Are you sure you want to delete this work stream? This action cannot be undone."
      }
    },
    capacityReport: {
      title: "Current Work Posture",
      useTriadView: "Use Triad View",
      additionalNotes: "Additional Notes (Optional)",
      additionalNotesPlaceholder: "Add any additional context about your current work posture...i.e. only paid work, only routine tasks...",
      triadDescription: "Urgent Obligations: Scheduled commitments & non-negotiable duties | Routine Work Energy: Work you can absorb into your rhythm | Generative / Exploratory Space: Capacity for open-ended or speculative work",
      triadAriaLabel: "Work Capacity Triad",
      triadAriaDescription: "Place your response in the triangle to indicate your current work capacity. The closer to a corner, the stronger that trait is in your current posture.",
    },
    emailReminders: {
      title: "Email Reminder Frequency",
      description: "How often would you like to receive email reminders about your open and active work streams, and any accountability requests?",
      none: "None",
      weekly: "Weekly",
      fortnightly: "Fortnightly",
      monthly: "Monthly",
      saveSuccess: "Reminder frequency updated",
      saveError: "Failed to update reminder frequency"
    },
    subtitle: "Shared containment and accountability view",
    livingWageHoursLink: "Paid work",
    todos: {
      title: "To-do list",
      subtitle: "Light personal tasks for {{name}}, including selected paid work.",
      openCount: "{{count}} open",
      add: "Add",
      addPlaceholder: "Add a to-do…",
      empty: "No to-dos yet. Add one here, from a meeting action, or by selecting paid work.",
      delete: "Delete to-do",
      toggle: "Mark {{title}} complete",
      fromMeeting: "From meeting",
      fromMeetingNamed: "From: {{title}}",
      livingWageBadge: "Paid work · {{hours}}h · {{status}}",
      livingWageSource: "Paid work",
      teamUpdateRequestSource: "Team request",
      livingWageEarningsChip: "Earnings · {{amount}}",
      livingWageEarningsTitle: "Accrued earnings",
      livingWageEarningsNote:
        "This is what the system has totalled from recorded work. It is not a limit on how much you should invoice — the system does not capture everything.",
      livingWageEarningsBreakdown:
        "{{completed}} from tasks ({{completedHours}}) · {{approved}} approved ({{approvedHours}}) at £{{rate}}/hr",
      meetingEarningsBreakdown:
        "Meetings · paid work {{livingWage}} ({{livingWageHours}}) · project budget {{project}} ({{projectHours}})",
      trackerEarningsBreakdown:
        "Budget tracker · {{amount}} ({{hours}})",
      earningsByMonthTitle: "By month",
      earningsMonthBreakdown:
        "Tasks {{tasks}} ({{taskHours}}) · approved {{approved}} ({{approvedHours}}) · meetings {{meetings}} ({{meetingHours}}) · tracker {{tracker}} ({{trackerHours}})",
      earningsMonthPending: "{{amount}} pending ({{hours}})",
      earningsInvoiced: "Invoiced",
      earningsPaid: "Paid",
      livingWagePending: "{{amount}} pending approval ({{hours}})",
      partnerInviteBadge: "Partner invite · {{hours}}h",
      partnerInviteFrom: "Invited by {{name}}",
      agreeToPartner: "Agree to partner",
      declinePartner: "Decline",
      partnerAccepted: "Partnership agreed — task added to your to-do list",
      partnerDeclined: "Partnership invite declined",
      openWorkStream: "Open work stream",
      linkAction: "Add to…",
      linkNewWorkStream: "New work stream",
      linkExistingWorkStream: "Existing work stream (as task)",
      linkAsTodo: "Personal to-do",
      addedAsTodo: "Added as to-do",
      added: "To-do added",
      deleted: "To-do deleted",
      addedFromMeeting: "Meeting action added as to-do",
      addedAsTask: "Meeting action added as work stream task",
      pickWorkStreamTitle: "Add to existing work stream",
      pickWorkStreamLabel: "Work stream",
      pickTodoOwnerTitle: "Whose to-do list?",
      pickTodoOwnerLabel: "Person",
      pickTodoOwnerHelp: "Choose who should see this on their work stream to-do list.",
    },
    tasks: {
      reserveViaLivingWage: "Reserve via Paid work",
      livingWageBadge: "£15ph Paid work",
      openForMoreClaims: "Open to more people",
      alsoClaimedBy: "Also claimed by: {{name}}",
    },
    addWorkStream: "Add Work Stream",
    editWorkStream: "Edit Work Stream",
    createWorkStream: "Create Work Stream",
    editDescription: "Update the details of this work stream. Changes will be visible to all collaborators.",
    createDescription: "Define a new work stream to track accountability and progress. This helps everyone understand who is responsible for what.",
    noData: "No accountability data yet",
    noDataDescription: "Click 'Add Work Stream' to get started",
    roles: {
      title: "Roles & Hats",
      purpose: "Purpose",
      authority: "Authority"
    },
    trials: {
      title: "Time-Bound Trials",
      daysRemaining: "Days Remaining",
      expired: "Expired {{days}} days ago",
      start: "Start",
      end: "End",
      primaryGoal: "Primary Goal",
      successSignals: "Success Signals",
      checkInCadence: "Check-in Cadence"
    },
    workLanes: {
      title: "Work Lanes",
      open: "Open & Active",
      blocked: "Blocked — Do Not Push",
      holding: "Paused / Dormant",
      empty: "No items in this lane"
    },
    workStream: {
      title: "Title",
      state: "State",
      continuityHolder: "Continuity Holder (User Key)",
      continuityHolderHelp: "The user key of the person accountable for this work",
      nextDecisionPoint: "Next Decision Point",
      nextDecisionPointHelp: "Date or condition text (e.g. 'When budget approved')",
      whatSilenceMeans: "What Silence Means",
      whatSilenceMeansHelp: "Explain what it means when nothing is happening with this work",
      fundingType: "Funding Type",
      affectedPeople: "Affected People (User Keys)",
      affectedPeopleHelp: "Comma-separated list of user keys",
      projectId: "Project ID (Optional)",
      projectIdHelp: "Link to a project if applicable",
      projectName: "Project",
      projectNameHelp:
        "Projects are budget trackers. Choose one or General company work.",
      generalCompanyWork: "General company work",
      renameProject: "Rename project",
      renameProjectTitle: "Rename project",
      renameProjectHelp:
        "Project names are owned by Budget Trackers. Rename the tracker there to update all work streams.",
      renameProjectLabel: "New project name",
      renameProjectSave: "Save name",
      renameProjectClear: "Move to General company work",
      renameProjectSuccess: "Updated project name on {{count}} work stream(s).",
      byProjectTab: "By Project",
      byProjectTitle: "By Project",
      byProjectSubtitle:
        "Named projects are budget trackers. General company workstreams use paid work rates.",
      states: {
        active: "Active",
        scheduled: "Scheduled",
        paused: "Paused",
        dormant: "Dormant",
        closed: "Closed",
        future: "Future"
      },
      fundingTypes: {
        funded_timebound: "Funded (Time-bound)",
        funded_flexible: "Funded (Flexible)",
        overhear_living_wage: "OVERHEAR Paid work (£15ph)",
        unfunded_strategic: "Unfunded (Strategic)",
        unfunded_optional: "Unfunded (Optional)"
      },
      fields: {
        continuityHolderLabel: "Continuity Holder",
        nextDecisionPointLabel: "Next Decision Point",
        whatSilenceMeansLabel: "What silence means",
        affectedPeopleLabel: "Affected People"
      }
    },
    validation: {
      titleRequired: "Title is required",
      continuityHolderRequired: "Continuity holder is required",
      whatSilenceMeansRequired: "What silence means is required",
      saveError: "Error saving work stream. Please try again.",
      holdingReasonRequired: "When work is unheld, you must provide a holding reason",
      unheldWorkStateInvalid: "Unheld work cannot be Active, Ongoing, or Scheduled. Please choose Paused, Dormant, or Future.",
      unheldWorkPermissionsInvalid: "When both task-level help and continuity pickup are not allowed, work can only be in Paused, Dormant, or Future state",
      endDateBeforeStartDate: "End date must be after start date",
      projectMustBeBudgetTracker:
        "Project must be an existing budget tracker (or General company work). Create or rename trackers in Budget Tracker.",
      completeRequiredFieldTitle: "Please complete the required field (Title) before navigating.",
      completeRequiredFieldSilence: "Please complete the required field (What silence means) before navigating.",
      deleteError: "Error deleting work stream. Please try again.",
      saveErrorWithDetails: "Error saving work stream: {{error}}. Please check the console for details.",
      mustBeLoggedIn: "You must be logged in to claim continuity.",
      claimContinuityError: "Error claiming continuity: {{error}}. Please try again.",
      dropContinuityError: "Error dropping continuity: {{error}}. Please try again.",
      claimTaskError: "Error claiming task. Please try again.",
      completeTaskError: "Error completing task. Please try again.",
      completeTaskExpenseError:
        "Task marked complete, but the project budget expense could not be saved. Check the budget tracker.",
      undoCompleteTaskError: "Error undoing completion. Please try again.",
      undoCompleteTaskExpenseError:
        "Task reopened, but the project budget expense could not be removed. Check the budget tracker.",
      dropTaskError: "Error dropping task. Please try again.",
      acceptInvitationError: "Error accepting invitation. Please try again.",
      continuityNotAllowed: "This work stream does not allow continuity to be claimed."
    },
    editor: {
      steps: {
        step0: {
          title: "Core Information",
          description: "What is this, who holds it, what's its posture? Start with the essential details: what this work is, who holds continuity, and its current state. These basics help everyone quickly understand the work stream's purpose and status.",
        },
        step1: {
          title: "Details & Context",
          description: "Why does this exist, and when is it \"enough\"? Add context, assumptions, and practical details. Define what silence means to establish the social contract. This step anchors meaning and helps collaborators understand the work's background, constraints, and completion criteria.",
        },
        step2: {
          title: "Work Status & Permissions",
          description: "What's allowed and what's constrained? Define decision-making authority, work status, and permissions. This step is governance, not meaning. It clarifies what can be done independently and what requires coordination or approval.",
        },
        step3: {
          title: "Tasks & Accountability",
          description: "How can others engage? Add specific tasks that others can help with, and optionally invite others to hold you accountable. This is where the social contract belongs.",
        }
      },
      sections: {
        completionCondition: {
          title: "Completion Condition",
          description: "When is this work \"enough\"? Define what completion or success looks like. This helps everyone understand when the work stream can be considered done or when it has achieved its purpose.",
          example: "'When the report is published and shared with stakeholders' or 'When the trial period ends and outcomes are documented'"
        },
        affectedPeople: {
          title: "Affected People",
          description: "Who else is impacted by or involved in this work? This helps people understand the scope and who to coordinate with.",
          example: "Select team members who need to be aware of progress or who will be impacted by decisions"
        },
        authorityNotes: {
          title: "Authority & Decision-Making",
          description: "Clarify what decisions can be made independently without seeking approval. This empowers the continuity holder and reduces unnecessary check-ins.",
          example: "'Can proceed independently on design decisions' or 'Can approve expenses up to £500 without consultation'"
        },
        blockedWork: {
          title: "Blocked Work",
          description: "If this work cannot proceed right now, mark it as blocked and explain why. This prevents others from pushing on work that's intentionally paused.",
          example: "Blocked by 'Waiting for funding decision' with review point '2024-03-15' or 'When funding is confirmed'"
        },
        commitmentCategory: {
          title: "Work Stream Category",
          description: "Choose whether this work is time-bound with specific dates, or ongoing open-ended work without start and end dates.",
          example: "Ongoing for standing responsibilities; Time-bound for a funded project phase or 90-day trial"
        },
        timeBoundCommitments: {
          title: "Time-Bound Commitments",
          description: "If this work has specific start and end dates (e.g., a 90-day trial or a funded project period), add them here. This helps everyone see time constraints and deadlines.",
          example: "Start date: 2024-01-01, End date: 2024-03-31 for a 90-day trial period"
        },
        whatSilenceMeans: {
          title: "What Silence Means",
          description: "Explain how inactivity should be interpreted. This defines the social contract around silence and tells others what they are allowed to assume about expectations.",
          examples: [
            {
              category: "Active, held work",
              items: [
                "In motion, no action needed: 'Silence means work is continuing; no check-in required unless the decision point arrives.'",
                "Updates only at milestones: 'Silence means nothing notable has changed. Updates will come at milestones, not continuously.'",
                "Quiet by design: 'Silence means I'm in deep work. Please don't nudge unless it's past the decision point.'",
                "Help welcome if it goes quiet: 'Silence means I may be stuck—feel free to offer task-level help, not continuity.'"
              ]
            },
            {
              category: "Trials (e.g., 90-day trials)",
              items: [
                "Learning phase: 'Silence means the trial is ongoing; don't infer progress or problems. Review happens at the scheduled check-in.'",
                "Protected space: 'Silence means space is being held for exploration. No intervention unless requested.'"
              ]
            },
            {
              category: "Unheld streams",
              items: [
                "No expectation: 'Silence means no work is expected unless someone explicitly opts in.'",
                "Waiting on external response: 'Silence means we're awaiting a reply; do not push until we hear back.'",
                "Open to take continuity: 'Silence means it remains available for someone to adopt; nothing is happening by default.'"
              ]
            },
            {
              category: "Paused",
              items: [
                "Intentionally paused: 'Silence means this is paused; don't chase it. We'll revisit at the decision point.'"
              ]
            },
            {
              category: "Dormant",
              items: [
                "Let it sleep: 'Silence means this is dormant; no updates expected unless reactivated.'"
              ]
            },
            {
              category: "Pre-decision (e.g., launch approach undecided)",
              items: [
                "Deliberation: 'Silence means the decision is still pending. Avoid acting or signalling until direction is agreed.'"
              ]
            }
          ]
        },
        nextDecisionPoint: {
          title: "Next Decision Point",
          description: "When or under what condition should this work be reviewed or a decision made? You can specify a date or a condition.",
          example: "Condition: 'When budget approved' or 'After the trial period'"
        },
        assumptions: {
          description: "Provisional interpretations about why this work is in its current state. These may be confirmed, challenged, or updated by others."
        },
        contributionTasks: {
          title: "Contribution Tasks",
          description: "Add small, independent tasks that others can help with. Contributing does not imply ongoing responsibility.",
          add: "Add task",
          titlePlaceholder: "e.g., 'Review transcript: Dorothy Parkes – Session 3'",
          hours: "Hours",
          hoursPlaceholder: "e.g. 2",
          allowMultiple: "Allow multiple people to claim this task",
          suggestPerson: "Suggest someone",
          suggestPersonPlaceholder: "Choose a teammate…",
          sendRequest: "Send as request",
          sendRequestQueued: "Request queued — will send when you save",
          requestSent: "Request sent",
          requestDialogTitle: "Send as a team update request",
          requestDialogHint:
            "Posts a request in a team chat asking them to take on this task. They can accept it into their to-do list.",
          requestChat: "Team chat",
          requestChatPlaceholder: "Select a chat…",
          requestChatRequired: "Choose a chat that includes this person",
          requestChatEmpty: "No team chats include this person yet. Add them to a chat first.",
          requestMessage: "Message",
          requestSendNow: "Send request",
          requestQueue: "Send when I save",
          requestDefaultBody:
            "Could you take on “{{task}}” on the work stream “{{stream}}”?",
          suggestedTo: "Suggested: {{name}}",
        },
        fullyTasked: {
          title: "Fully tasked",
          description: "Turn on when this work stream has a full complement of tasks so someone can pick it up and complete it properly. Leave off while tasks still need defining or filling out.",
          onHint: "Tasks are complete — this stream is ready to pick up.",
          offHint: "Tasks still need filling out before this stream is ready to pick up.",
          needsTasks: "Add at least one task before marking this stream as fully tasked."
        }
      }
    }
}